<template>
  <div class="ret-overlay" @click.self="$emit('close')">
    <div class="ret-modal">
      <div class="ret-hdr">
        <span>退回补充材料 · {{ companyName }}</span>
        <button class="ret-close" @click="$emit('close')">✕</button>
      </div>
      <div class="ret-body">
        <div class="ret-opt on">
          <div class="ro-t">↩ 退回补充材料</div>
          <div class="ro-d">
            问题整改后自动回到客服审核队列，已通过环节记录保留 ——
            资料可补救时选用
          </div>
        </div>
        <label
          class="fld-lbl"
        ><span class="req">*</span>问题归类（点选，将精确定位到需重传的证件 /
          尽调项）</label>
        <div class="chip-pick">
          <span
            v-for="c in chips"
            :key="c"
            class="chip"
            :class="{ on: selectedChips.includes(c) }"
            @click="toggleChip(c)"
          >{{ c }}</span>
        </div>
        <label
          class="fld-lbl"
        ><span class="req">*</span>退回说明（按角色语言分别通知客户经理与托运人业务负责人）</label>
        <el-input
          v-model="remark"
          type="textarea"
          :rows="3"
          placeholder="如：营业执照影像模糊，无法核验注册地址与信用代码，请重新拍摄后上传；法人身份证已过期，请更新有效证件"
          size="small"
        />
        <div class="ret-notice">
          退回后：① 客户经理收到待办与短信提醒 ②
          客户经理联系客户后可代为重传证件 / 补充尽调 ③
          重新提交自动回到客服审核队列
        </div>
      </div>
      <div class="ret-footer">
        <el-button size="small" @click="$emit('close')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="onConfirm"
        >确认退回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReturnDialog",
  props: {
    companyName: { type: String, default: "" },
    applyCode: { type: String, default: "" },
    trackRole: { type: String, default: "" }
  },
  data() {
    return {
      chips: [
        "营业执照",
        "法人身份证",
        "业务负责人身份证",
        "道路运输经营许可证",
        "历史发货佐证",
        "经营场所核实",
        "费率合理性",
        "其他"
      ],
      selectedChips: [],
      remark: "",
      loading: false
    };
  },
  methods: {
    toggleChip(c) {
      const i = this.selectedChips.indexOf(c);
      if (i > -1) this.selectedChips.splice(i, 1);
      else this.selectedChips.push(c);
    },
    onConfirm() {
      if (!this.remark.trim()) {
        this.$message.warning("请填写退回说明");
        return;
      }
      this.loading = true;
      const chipText = this.selectedChips.length
        ? "【" + this.selectedChips.join("、") + "】"
        : "";
      const fullRemark = chipText + this.remark;
      this.$emit("confirm", {
        action: "RETURN",
        remark: fullRemark,
        chips: this.selectedChips
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ret-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 17, 30, 0.45);
  z-index: 2100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 6vh 18px 18px;
  overflow-y: auto;
}
.ret-modal {
  background: #fff;
  border-radius: 14px;
  width: 520px;
  max-width: 100%;
  box-shadow: 0 24px 64px -12px rgba(16, 24, 40, 0.35);
}
.ret-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 15px;
  font-weight: 700;
}
.ret-close {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ret-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.ret-body {
  padding: 18px;
}
.ret-opt {
  border: 1.5px solid #426df0;
  background: #f7f9ff;
  border-radius: 11px;
  padding: 12px 14px;
  margin-bottom: 16px;
}
.ret-opt .ro-t {
  font-weight: 700;
  font-size: 13px;
  margin-bottom: 4px;
}
.ret-opt .ro-d {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
}
.fld-lbl {
  font-size: 12.5px;
  font-weight: 500;
  color: #334155;
  margin-bottom: 7px;
  display: block;
}
.fld-lbl .req {
  color: #ef4444;
}
.chip-pick {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.chip {
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 5px 13px;
  font-size: 12.5px;
  cursor: pointer;
  transition: 0.15s;
  background: #fff;
}
.chip:hover {
  border-color: #cbd5e1;
}
.chip.on {
  border-color: #ef4444;
  color: #cf1322;
  background: #fef2f2;
  font-weight: 600;
}
.ret-notice {
  font-size: 12.5px;
  color: #64748b;
  background: #f6f8fc;
  border: 1px solid #f1f5f9;
  border-radius: 10px;
  padding: 11px 14px;
  margin-top: 14px;
  line-height: 1.7;
}
.ret-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #f1f5f9;
  background: #fafbfd;
  border-radius: 0 0 14px 14px;
}
</style>
